import { render } from "./blog-hero.vue?vue&type=template&id=2544eb3c&scoped=true"
import script from "./blog-hero.vue?vue&type=script&lang=js"
export * from "./blog-hero.vue?vue&type=script&lang=js"

import "./blog-hero.vue?vue&type=style&index=0&id=2544eb3c&lang=css"
import "./blog-hero.vue?vue&type=style&index=1&id=2544eb3c&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2544eb3c"]])

export default __exports__